var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('b-table',{attrs:{"small":"","responsive":"","hover":"","fields":_vm.fields,"items":_vm.mappingRateData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }